import { render, staticRenderFns } from "./ot-project-contracts-index.vue?vue&type=template&id=0d1ab2fb&scoped=true&"
import script from "./ot-project-contracts-index.vue?vue&type=script&lang=ts&"
export * from "./ot-project-contracts-index.vue?vue&type=script&lang=ts&"
import style0 from "./ot-project-contracts-index.vue?vue&type=style&index=0&id=0d1ab2fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1ab2fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VForm } from 'vuetify/lib/components/VForm';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAlert,VForm,VMenu})
